/**
 * Block Login
 */
(function() {
    $(document).ready(function() {
        if ($('.js24Login').length) {
            const oLogin = $('.js24Login');

            // Shows the last Login block with Delay
            setTimeout(function() {
                if ($('.js24Continue').is(':visible') && $('.js24LocalStorage', oLogin).length && $('.js24Default', oLogin).length) {
                    $('.js24Default', oLogin).hide();
                    $('.js24LocalStorage', oLogin).show();
                }
                oLogin.stop().slideDown(400, function() {
                    $(this).removeClass('c24Hidden');

                    window.c24LpFrameJsReady.then(function() {
                        const oHoldingLogin = $('.mod24BlockLoginLink.js24OpenLoginLayer');
                        if (oHoldingLogin.length) {
                            window._paq.push([
                                'trackEvent',
                                'PSS_' + window.c24LpKey,
                                'AnmeldenLink_showed',
                                window.c24LpKey,
                            ]);
                            $('.mod24BlockLoginLink.js24OpenLoginLayer').on('click', function() {
                                window._paq.push([
                                    'trackEvent',
                                    'PSS_' + window.c24LpKey,
                                    'AnmeldenLink_clicked',
                                    window.c24LpKey,
                                ]);
                            });
                        }
                    });

                });
            }, 600);
        }
    });
})();
